<template>
  <div>
    <page-title
      icon="fas fa-apple-alt"
      main="Comercial HF">
    </page-title>

      <div class="card mt-2" style="padding: 0rem 1rem">
        <div class="row">
          <div  class="col-lg-12 card-header">
              <h5 class="h3 mb-0">Comercial</h5>
              <h6 class="text-uppercase text-muted ls-1 mb-1">  Configure quais dados deverão ser listados:  </h6>
            </div>

          <div class="col-md-3 mt-3">
            <label class="form-control-label">Cargo</label>
            <multiselect
              v-model="valueCargo"
              :options="options"
              :select-label="''"
              :selected-label="'Selecionado'"
              :deselect-label="''"
              placeholder="Cargo"
              :required="true"

            />
          </div>

          <div class="col-md-3 mt-3">
            <label class="form-control-label">Periodo de Vigência</label>
            <multiselect
              v-model="anoParticipation"
              :select-label="''"
              :selected-label="'Selecionado'"
              :deselect-label="''"
              :options="participation"
              label="descricao"
              placeholder="Período de Vigência"
              track-by="id"
              :allow-empty="false"
            />
          </div>

          <div class="col-md-6 mt-5">
            <base-button icon type="info" v-on:click="search">
              <span class="btn-inner--icon">
                <i class="fa fa-search"></i>
              </span>
              <span class="btn-inner--text">Pesquisar</span>
            </base-button>
            <base-button
              type="secondary"
              class="mr-2"
              @click="clearFilters">
              Limpar Filtros
            </base-button>
          </div>
        </div>


        <div v-loading="loading.distributions" class="row" style="margin-bottom: 50px; margin-top: 30px;">
          <div class="col" v-for="distribution in distributions" :key="distribution.id">
              <base-button icon type="info" style="width: 250px;display: flex; height: 90px" @click="clickedAll(distribution.id), showAlert">
                <span class="btn-inner--text" style="padding-top: 20px">
                  {{distribution.descricao}}
                  <p><strong>Peso 35%</strong></p>
                </span>
              </base-button>
          </div>
        </div>
      </div>

      <div v-loading="loading.getComercialPpr">
        <div v-for="group in percentageWithGroups" :key="group.id">
          <card v-if="condition_1">
            <h3>{{group.descricao}}</h3><br>
            <el-table
              id="table"
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              :data="group.percentages"
              stripe="stripe"
              border
              style="width: 100%;"
            >
              <el-table-column
                label="Percentual atingido"
                prop="percentage_reached"
                max-width="30px"
                sortable
                :disabled="editablePeriod">
                <template slot-scope="scope">
                  <base-input v-model="scope.row.percentage_reached" mask="volume" @blur="handleEditRow(scope.row)" slot="empty"></base-input>
                </template>
              </el-table-column>

              <el-table-column
                label="Percentual de participação"
                prop="percentage_partipation"
                min-width="30px"
                sortable
                :disabled="editablePeriod">
                <template slot-scope="scope">
                  <base-input v-model="scope.row.percentage_partipation" mask="volume" @blur="handleEditRow(scope.row)" slot="empty"></base-input>
                </template>
              </el-table-column>
            </el-table>
          </card>
        </div>
      </div>
  </div>
</template>

<script>
import Vue from "vue";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Modal from "@/components/Modal";
import {DatePicker} from "element-ui";
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui';
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import swal from 'sweetalert2';
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
    name: "app",
    components: {
      PageTitle,
      Multiselect,
      Modal,
      [DatePicker.name]: DatePicker,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        loading: {
          distributions: false,
          getComercialPpr: false,
        },
        anoPpr: {},
        periods: [],
        anoParticipation: [],
        participation: [],
        empty: 'Sem dados',
        valueCargo: null,
        options:['Vendedor', 'Gerente Comercial', 'Coordenador'],
        roleSelected: "",
        start_data: 'Data de Início',
        end_date: 'Data de Fim',
        rowExpanded: {},
        condition_1: false,
        condition_2: false,
        comercialPpr: "",
        newArray: [],
        distributions: [],
        distribution_id: "",
        groups: [],
        percentages: [],
        loadedPercentages: false,
        users: "",
        goal: {
          salesman_id : ""
        },
        percentageWithGroups: [],
        userPercentageGoal: "",
        usersWithPercentage: [],
        salesmen_type: "",
        noQuery: true,
        comercialId: "",
        initial: [
          {
            descricao: "META DE VENDAS EM R$",
            percentages:
              [
                {percentage_reached: 'Igual ou acima de 120,00%',percentage_partipation: '0,0%',grupo: {descricao: "OUTROS"}},
                {percentage_reached: 'De 110,00% a 119,99%',percentage_partipation: '0,0%',grupo: {descricao: "OUTROS"}},
                {percentage_reached: 'De 100,00% a 109,99%',percentage_partipation: '0,0%',grupo: {descricao: "OUTROS"}},
                {percentage_reached: 'De 90,00% a 99,99%',percentage_partipation: '0,0%',grupo: {descricao: "OUTROS"}},
                {percentage_reached: 'De 80,00% a 89,99%',percentage_partipation: '0,0%',grupo: {descricao: "OUTROS"}},
                {percentage_reached: 'Abaixo de 80%',percentage_partipation: '0',grupo: {descricao: "OUTROS"}}
              ]
          },
          {
            descricao: "META DE VENDAS PRODUTOS ESTRATÉGICOS EM R$",
            percentages:
            [
              {percentage_reached: 'Igual ou acima de 120,00%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 110,00% a 119,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 100,00% a 109,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 90,00% a 99,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 80,00% a 89,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'Abaixo de 80%',percentage_partipation: '0',grupo: {descricao: "NUTRIÇÃO"}}
            ]
          },
          {
            descricao: "MARGEM BRUTA",
            percentages:
            [
              {percentage_reached: 'Igual ou acima de 120,00%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 110,00% a 119,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 100,00% a 109,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 90,00% a 99,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 80,00% a 89,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'Abaixo de 80%',percentage_partipation: '0',grupo: {descricao: "NUTRIÇÃO"}}
            ]
          },
          {
            descricao: "ADIMPLÊNCIA CONSOLIDADA HF",
            percentages:
            [
              {percentage_reached: 'Igual ou acima de 120,00%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 110,00% a 119,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 100,00% a 109,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 90,00% a 99,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'De 80,00% a 89,99%',percentage_partipation: '0,0%',grupo: {descricao: "NUTRIÇÃO"}},
              {percentage_reached: 'Abaixo de 80%',percentage_partipation: '0',grupo: {descricao: "NUTRIÇÃO"}}
            ]
          }
        ],
        //modal0: false,
      }
    },
    mounted() {
      this.getPeriods();
      this.getParticipation();
      this.numberFormatter();
    },
    methods: {
      getPeriods() {
      this.$http.secured
        .get("/api/v1/admin/settings/periods")
        .then((response) => {
          this.periods = response.data;
        });
      },
      search() {
        if(!this.valueCargo || Object.keys(this.valueCargo).length == 0) {
          this.showAlert('Selecione um cargo para continuar')
          return
        }
        if(!this.anoParticipation || Object.keys(this.anoParticipation).length == 0) {
          this.showAlert('Selecione um período de vigência para continuar')
          return
        }

        this.getDistributions();
        this.getGroups();
      },
      showAlert(string) {
        this.$toasted.global.defaultError({ msg: string || 'Selecione um usuário e um período de vigência.' });
      },
      register() {
        this.percentageWithGroups = this.initial
        this.loadedPercentages = true

      },
      clickedAll(clickedAll){
        this.distribution_id = clickedAll
        this.getComercialPpr();
      },
      clickedOthers(){
        this.condition_1 = true;
        this.condition_2 = false;
      },
      numberFormatter(row, column, value) {
        if (!value) return 0;

        return value.toFixed(2);
      },
      handleEditRow(index) {
        this.$http.secured
          .put(`/api/v1/porcentagens_pprs/${index.id}`, index )
          .then(response => console.log(response.data))
          .catch(error => console.log(error));
      },
      async getComercialPpr() {
        this.loading.getComercialPpr = true

        let is_salesman = false
        let is_manager = false
        let is_coordinator = false

        if(this.valueCargo == "Vendedor") {
          is_salesman = true
          is_manager = false
          is_coordinator = false
        }
        else if(this.valueCargo == "Gerente Comercial") {
          is_salesman = false
          is_manager = true
          is_coordinator = false
        }
        else if(this.valueCargo == "Coordenador") {
          is_salesman = false
          is_manager = false
          is_coordinator = true
        }

        var dataComercial = {
          q: {
            participation_ppr_id: this.anoParticipation.id,
            is_salesman: is_salesman,
            is_manager: is_manager,
            is_coordinator: is_coordinator,
            tipe: 'HF',
          }, //Filtrando por id de distribuicao
        };

        console.log("[PprHf][getComercialPpr] dataComercial", dataComercial)

      let grupos = this.groups
      let percentageWithGroups = this.percentageWithGroups
      let newArray = []
      this.$http.secured
        .get("/api/v1/comercial_pprs", { params: dataComercial })
        .then((response) => {
          console.log(response)
          this.comercialPpr = response.data
          let comercialId = response.data[0].id

          var dataPorcentagens = {
            q: {
              comercial_ppr_id: comercialId,
              distribution_id: this.distribution_id
            }, //Filtrando por id de distribuicao
          };

          console.log("[PprHf][getComercialPpr] dataPorcentagens", dataPorcentagens)

          this.$http.secured
            .get("/api/v1/porcentagens_pprs", { params: dataPorcentagens })
            .then((response) => {
              this.loading.getComercialPpr = false

              this.percentages = response.data //porcentagens referentes a esse comercial
              .forEach(function(porcentagem) {
                porcentagem.percentage_reached     = Math.round(100 * (porcentagem.percentage_reached || 0)) / 100;
                porcentagem.percentage_partipation = Math.round(100 * (porcentagem.percentage_partipation || 0)) / 100;

                grupos.forEach(function(grupo){
                  if(porcentagem.grupo.descricao == grupo.descricao && porcentagem.comercial_ppr_id == comercialId) {
                    percentageWithGroups.push({
                      grupo: grupo.descricao,
                      percentages: porcentagem
                    })
                  }
                })
              })
              percentageWithGroups.forEach(function(obj) {
                let novoArray = newArray.find(array => array.descricao == obj.grupo)
                if (novoArray) novoArray.percentages.push(obj.percentages)
                else if(obj.grupo != null){
                  newArray.push({
                    descricao: obj.grupo,
                    percentages: [obj.percentages]
                  })
                }
              })
              console.log(newArray)
              this.percentageWithGroups = newArray
              console.log(this.percentageWithGroups)
              this.loadedPercentages = true
            })
          });
      },
      async getDistributions() {
        this.loading.distributions = true
        try {
          const response = await this.$http.secured.get("/api/v1/distributions")
          console.log("[PprHf][getDistributions] response.data", response.data);
          this.distributions = response.data;
        } catch (error) {
          console.warn("[PprHf][getDistributions] requisition error: ", error)
        }
        this.loading.distributions = false
      },
      async getGroups() {
        try {
          const response = await this.$http.secured.get("/api/v1/grupos")
          console.log("[PprHf][getGroups] response.data", response.data);
          this.groups = response.data
        } catch (error) {
          console.warn("[PprHf][getGroups] requisition error: ", error)
        }
      },
      async getParticipation(){
        try {
          const response = await this.$http.secured.get(`/api/v1/admin/participation_pprs`, { params: { unpaged: true } })
          console.log("[PprHf][getParticipation] response.data", response.data);
          this.participation = response.data;
        } catch (error) {
          console.warn("[PprHf][getParticipation] requisition error: ", error)
        }
      },
      clearFilters() {
        this.valueCargo = null,
        this.anoParticipation= []
      },
    },
    computed: {
      editablePeriod: function () {
        if(!this.anoPpr.is_open) return false

        return (new Date(this.periods["goal_register_period"]) <= currentDate) && (currentDate <= new Date(this.periods["goal_end_date"]))
      },
      dateRange: {
        get: function() {
            // eslint-disable-next-line
          /* eslint-disable */
          return [this.start_date, this.end_date];
        },
        set: function(range) {
            // eslint-disable-next-line
          /* eslint-disable */
          [this.start_date, this.end_date] = range;
        },
      },
    },
    watch: {
      'users': function() {
        this.users.map(user => this.getPorcentagensUser(user))
      },
      'usersWithPercentage': function() {
        deep: true
      },
      'loadedPercentages': function() {
        this.condition_1 = true;
        this.condition_2 = true;
      },
      'distribution_id': function() {
        // this.getComercialPpr();
      },
      start_date: function(){
        this.campaign.start_date = this.start_date
      },
      end_date: function(){
        this.campaign.end_date = this.end_date
      },
    },
};
</script>
